module.exports = __webpack_public_path__ + "static/img/logo15.3d66140.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo15.jpg
// module id = Vrdl
// module chunks = 1